import React from "react";
import "./style.css";

export const Title = ({
  className = "",
  title,
  subtitle,
  icon,
  description,
}) => {
  return (
    <div className={`title-wrapper position-relative ${className}`}>
      <div className="title">
        {subtitle && (
          <div className="subtitle">
            {icon && <img src={icon} title={subtitle} alt="The Instantors" />}

            <span>{subtitle}</span>
          </div>
        )}
        <h2>{title}</h2>
        {description && <div className="description">{description}</div>}
      </div>
    </div>
  );
};
